import { useContext } from "react";
import { AuthContext } from "../../auth/AuthContext";
import {
  MenuItem,
  useTheme,
  alpha,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExitToApp } from "@mui/icons-material";

function LogoutMenuItem() {
  const theme = useTheme();
  const { logout } = useContext(AuthContext);

  return (
    <MenuItem
      onClick={logout}
      sx={{
        py: 1.5,
        "&:hover": {
          backgroundColor: alpha(theme.palette.error.main, 0.1),
          color: theme.palette.error.main,
        },
      }}
    >
      <ListItemIcon sx={{ color: "inherit" }}>
        <ExitToApp fontSize="small" />
      </ListItemIcon>
      <ListItemText>Logout</ListItemText>
    </MenuItem>
  );
}

export default LogoutMenuItem;
